var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-number-field" }, [
    _vm.$slots.default
      ? _c(
          "div",
          { staticClass: "app-number-field__label" },
          [_vm._t("default")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "app-number-field__input-wrapper",
        class: {
          "app-number-field__input-wrapper--disabled": _vm.$attrs.disabled,
          "app-number-field__input-wrapper--error": _vm.hasError
        }
      },
      [
        _c(
          "input",
          _vm._b(
            {
              staticClass: "app-number-field__input",
              attrs: { type: "number", step: "any" },
              on: {
                input: _vm.inputHandler,
                keypress: _vm.keyPressHandler,
                keydown: _vm.keyDownHandler,
                paste: function($event) {
                  $event.preventDefault()
                },
                invalid: _vm.setInvalidMessage
              }
            },
            "input",
            _vm.$attrs,
            false
          )
        ),
        _vm._v(" "),
        _c("div", { staticClass: "app-number-field__ticks" }, [
          _c("span", {
            staticClass: "arrow arrow--up",
            on: {
              click: function($event) {
                return _vm.update(1)
              }
            }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "arrow arrow--down",
            on: {
              click: function($event) {
                return _vm.update(-1)
              }
            }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _vm.hasError
      ? _c("p", { staticClass: "app-number-field__error" }, [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.invalidMessage || _vm.error) + "\n\t\t"
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6696737d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6696737d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppNumberField.vue
// module id = null
// module chunks = 